// i18n
import 'src/locales/i18n';

// scrollbar
import 'simplebar-react/dist/simplebar.min.css';

// lightbox
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

// map
import 'mapbox-gl/dist/mapbox-gl.css';

// editor
import 'react-quill/dist/quill.snow.css';

// carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// image
import 'react-lazy-load-image-component/src/effects/blur.css';

// ----------------------------------------------------------------------

import { Navigate, useLocation } from 'react-router-dom';
// routes
import Router from 'src/routes/sections';
// theme
import ThemeProvider from 'src/theme';
// locales
import { LocalizationProvider } from 'src/locales';
// hooks
import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
// components
import ProgressBar from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import SnackbarProvider from 'src/components/snackbar/snackbar-provider';
import toast, { SnackbarUtilsConfigurator } from 'src/utils/snackbar-notification'
import { SettingsProvider, SettingsDrawer } from 'src/components/settings';
// sections
import { CheckoutProvider } from 'src/sections/checkout/context';
// auth
import { AuthProvider, AuthConsumer } from 'src/auth/context/jwt';

import "prosemirror-view/style/prosemirror.css";

import { Provider } from 'react-redux';
import store from 'src/store';
import { useState, useMemo, lazy , useEffect} from 'react';
import { 
  ConfigContext,
  typeIDContext,
  NewFormContext,
  FormShareContext, 
  DragEventContext,
  FormShareIDContext,
  SubscriptionContext,
  ModificationContext, 
  ModalSynchronizationContext,
  ModalRiseInCompetenceContext,
} from 'src/context/Context';
import { AIPromptProvider } from 'src/components/ia/context/Context';
// import { AuthProvider, AuthConsumer } from 'src/auth/context/auth0';
// import { AuthProvider, AuthConsumer } from 'src/auth/context/amplify';
// import { AuthProvider, AuthConsumer } from 'src/auth/context/firebase';

const AuthFormStore = lazy(() =>
  import('src/auth/guard/auth-form').then((module) => ({ default: module.AuthFormStore }))
);

// ----------------------------------------------------------------------


export default function App() {
  const charAt = `

  ░░░    ░░░
  ▒▒▒▒  ▒▒▒▒
  ▒▒ ▒▒▒▒ ▒▒
  ▓▓  ▓▓  ▓▓
  ██      ██

  `;

  /* console.info(`%c${charAt}`, 'color: #5BE49B'); */


  useScrollToTop();

  const [typeID, setTypeID] = useState();
  const [offreID, setOffreID] = useState();
  const [signed, setSigned] = useState(false);
  const [syncData, setSyncData] = useState([]);
  const [newForm, setNewForm] = useState(false);
  const [showRIC, setShowRIC] = useState(false);
  const [signature, setSignature] = useState(null);
  const [dragEvent , setDragEvent] = useState(null);
  const [idQuestion, setIdQuestion] = useState(null);
  const [activePlan, setactivePlan] = useState(false);
  const [abonnement, setAbonnement] = useState(false);
  const [formShareID, setFormShareID] = useState(false);
  const [subscription, setSubscription] = useState(false);
  const [profileSave , setProfileSave ] = useState(false);
  const [showFormShare, setShowFormShare] = useState(false);
  const [showSyncModal, setShowSyncModal] = useState(false);
  const [modification , setModification ] = useState(false);
  const [documentView , setDocumentView ] = useState(false);
  const [documentStyle , setDocumentStyle ] = useState(false);
  const [reloadModalShare , setReloadModalShare ] = useState(false);
  const [remainingTrainees , setRemainingTrainees ] = useState(false);

  const FormShareContextValue = useMemo(
    () => ({
      showFormShare,
      reloadModalShare,
      updateFormShare: setShowFormShare,
      updateReloadModalShare: setReloadModalShare,
    }),
    [showFormShare, reloadModalShare]
  );

  const FormShareIDContextValue = useMemo(
    () => ({
      formShareID,
      updateFormShareID: setFormShareID,
    }),
    [formShareID]
  );

  const SubscriptionContextValue = useMemo(
    () => ({
      offreID,
      activePlan,
      abonnement,
      subscription,
      remainingTrainees,
      updateOffreID: setOffreID,
      updateActivePlan: setactivePlan,
      updateAbonnement: setAbonnement,
      updateSubscription: setSubscription,
      updateRemainingTrainees: setRemainingTrainees,
    }),
    [subscription, abonnement, activePlan, remainingTrainees, offreID]
  );

  const DragEventContextValue = useMemo(
    () => ({
      dragEvent,
      updateDagEvent: setDragEvent,
    }),
    [dragEvent]
  );

  const ModificationContextValue = useMemo(
    () => ({
      modification,
      updateModification: setModification,
    }),
    [modification]
  );

  const NewFormContextValue = useMemo(
    () => ({
      newForm,
      updateNewForm: setNewForm,
    }),
    [newForm]
  );

  const ModalRiseInCompetenceContextValue = useMemo(
    () => ({
      showRIC,
      idQuestion,
      updateRICModal: setShowRIC,
      updateIdQuestion: setIdQuestion,
    }),
    [showRIC, idQuestion]
  );

  const ModalSynchronizationContextValue = useMemo(
    () => ({
      syncData,
      showSyncModal,
      updateSyncData: setSyncData,
      updateShowSyncModal: setShowSyncModal,
    }),
    [showSyncModal, syncData]
  );

  const TypeIDContextValue = useMemo(
    () => ({
      typeID,
      updateTypeID: setTypeID,
    }),
    [typeID]
  );

  const ConfigContextValue = useMemo(
    () => ({
      signed,
      signature,
      profileSave,
      documentView,
      documentStyle,
      updateSigned: setSigned,
      updateSignature: setSignature,
      updateProfileSave: setProfileSave,
      updateDocumentView:setDocumentView,
      updateDocumentStyle:setDocumentStyle,
    }),
    [signed, signature, documentView, documentStyle, profileSave]
  );

  // useEffect(() => {
  //   toast.success("SUCCCCCCCCCCCCeSSSSSS")
  // }, []);
  
  return (
    <AuthProvider>
      <LocalizationProvider>
        <SettingsProvider
          defaultSettings={{
            themeMode: 'light', // 'light' | 'dark'
            themeDirection: 'ltr', //  'rtl' | 'ltr'
            themeContrast: 'default', // 'default' | 'bold'
            themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
            themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
            themeStretch: false,
          }}
        >
          <ThemeProvider>
            <AIPromptProvider>
              <MotionLazy>
                <SnackbarProvider>
                <SnackbarUtilsConfigurator />
                  <CheckoutProvider>
                    <SettingsDrawer />
                    <ProgressBar />

                    <Provider store={store}>
                      <AuthFormStore>
                        <SubscriptionContext.Provider value={SubscriptionContextValue}>
                        <ModificationContext.Provider value={ModificationContextValue}>
                          <ModalRiseInCompetenceContext.Provider value={ModalRiseInCompetenceContextValue}>
                            <FormShareContext.Provider value={FormShareContextValue}>
                              <FormShareIDContext.Provider value={FormShareIDContextValue}>
                                <DragEventContext.Provider value={DragEventContextValue}>
                                <NewFormContext.Provider value={NewFormContextValue}>
                                  <ModalSynchronizationContext.Provider value={ModalSynchronizationContextValue}>
                                    <typeIDContext.Provider value={TypeIDContextValue}>
                                      <ConfigContext.Provider value={ConfigContextValue}>
                                        <Router />
                                      </ConfigContext.Provider>
                                    </typeIDContext.Provider>
                                  </ModalSynchronizationContext.Provider>
                                </NewFormContext.Provider>
                                </DragEventContext.Provider>
                              </FormShareIDContext.Provider>
                            </FormShareContext.Provider>
                          </ModalRiseInCompetenceContext.Provider>
                        </ModificationContext.Provider>
                        </SubscriptionContext.Provider>
                        </AuthFormStore>
                    </Provider>
                  </CheckoutProvider>
                </SnackbarProvider>
              </MotionLazy>
            </AIPromptProvider>
          </ThemeProvider>
        </SettingsProvider>
      </LocalizationProvider>
    </AuthProvider>
  );
}
